import Vue from 'vue'
import Router from 'vue-router'

const tkamc = r => require(['@/views/tkamc'], r) //--登陆后 路由公共部分
const login = r => require(['@/views/login'], r) //--登录

/************************* 注册开户  *************************/
const registerComm = r => require(['@/views/register/registerComm'], r) //-- 注册开户相关的 公用路由
const register_phone = r => require(['@/views/register/register_phone'], r) //-- 注册账号(手机验证)
const register_setPwd = r => require(['@/views/register/register_setPwd'], r) //-- 注册账号(设置密码)
const register_phone_result = r => require(['@/views/register/register_phone_reult'], r) //-- 注册结果
const register_bank = r => require(['@/views/register/register_bank'], r) //-- 开户(实名认证)
// const register_bankCallBack = r => require(['@/views/register/register_bankCallBack'],r) //-- 开户(实名认证--银行回调)
const register_info = r => require(['@/views/register/register_info'], r) //-- 开户(资料填写)
const register_risk = r => require(['@/views/register/register_risk'], r) //-- 开户(风险测评)
const register_riskResult = r => require(['@/views/register/register_riskResult'], r) //-- 开户(风险测评结果)
const register_resetPwdCheck = r => require(['@/views/register/register_resetPwdCheck'], r) //-- 开户(安全校验)
const register_resetPwd = r => require(['@/views/register/register_resetPwd'], r) //-- 开户(重置密码--弱密码校验)
const register_success = r => require(['@/views/register/register_result_success'], r) //-- 开户成功
const register_fail = r => require(['@/views/register/register_result_fail'], r) //-- 开户失败 

/************************* 忘记密码 *************************/
const forgetpwdSelect = r => require(['@/views/forgetPwd/forgetpwdSelect'], r) //-- 找回密码 - 选择找回类型
const forgetpwdPhone = r => require(['@/views/forgetPwd/forgetpwdPhone'], r) //-- 找回密码 - 手机找回 -验证手机
const forgetpwdInfo = r => require(['@/views/forgetPwd/forgetpwdInfo'], r) //-- 找回密码 - 证件信息
const forgetpwdBank = r => require(['@/views/forgetPwd/forgetpwdBank'], r) //-- 找回密码 - 银行卡信息
const forgetpwdSetpwd = r => require(['@/views/forgetPwd/forgetpwdSetpwd'], r) //-- 找回密码 - 设置新密码
const forgetpwdResult = r => require(['@/views/forgetPwd/forgetpwdResult'], r) //-- 找回密码 - 结果

/************************* 我的资产 *************************/
const myaccount = r => require(['@/views/accountInfo/myaccount'], r); //--我的资产
const myaccount_inTheWay = r => require(['@/views/accountInfo/myaccountInTheWay'], r); //--在途交易
const myaccount_info = r => require(['@/views/accountInfo/myaccountInfo'], r); //--持仓详情
const myaccount_income = r => require(['@/views/accountInfo/myaccountIncome'], r); //-- 累计收益
const q_accountQuery = r => require(['@/views/accountInfo/accountQuery'], r); //-- 账户查询

/********************** 基金购买 **********************/
const fundsList = r => require(['@/views/fundBuy/fundsList'], r) //-- 基金列表)
const fundPurchases = r => require(['@/views/fundBuy/fundPurchases'], r) //-- 某一基金购买
const fundPurchases_success = r => require(['@/views/fundBuy/fundPurchases_success'], r) //-- 基金购买 成功
const fundPurchases_success_remits = r => require(['@/views/fundBuy/fundPurchases_success_remits'], r) //-- 申购汇款成功
const fundPurchases_fail = r => require(['@/views/fundBuy/fundPurchases_fail'], r) //-- 基金购买 失败

/********************** 基金定投 **********************/
const fundsDate = r => require(['@/views/fundfixed/fundsDate'], r) //-- 基金定投
const fundsDate_buy = r => require(['@/views/fundfixed/fundsDate_buy'], r) //-- 基金定投 某一基金定投
const fundsDate_buyNew = r => require(['@/views/fundfixed/fundsDate_buyNew'], r) //-- 基金定投 新增定投计划
const fundsDate_buy_result = r => require(['@/views/fundfixed/fundsDate_buy_result'], r) //-- 基金定投 成功
const fundsDate_edit = r => require(['@/views/fundfixed/fundsDate_edit'], r) //-- 基金定投 修改
const fundsDate_edit_result = r => require(['@/views/fundfixed/fundsDate_edit_result'], r) //-- 基金定投 修改结果

/********************** 基金赎回 **********************/
const fundRedeem = r => require(['@/views/fundRedeemOrTransform/fundRedeem'], r) //-- 基金赎回
const fundRedeem_result = r => require(['@/views/fundRedeemOrTransform/fundRedeem_result'], r) //-- 基金赎回 结果

/********************** 基金转换 **********************/
const fundTransform = r => require(['@/views/fundRedeemOrTransform/fundTransform'], r) //-- 基金转换
const fundTransform_result = r => require(['@/views/fundRedeemOrTransform/fundTransform_result'], r) //-- 基金转换 成功

/********************** 赎回转认购 **********************/
const redeemBuyList = r => require(['@/views/redeemBuy/redeemBuyList'], r) //-- 赎回转认购 信息列表
const redeemBuy = r => require(['@/views/redeemBuy/redeemBuy'], r) //-- 赎回转认购
const redeemBuyNew = r => require(['@/views/redeemBuy/redeemBuyNew'], r) //-- 新增赎回转认购
const redeemBuyResult = r => require(['@/views/redeemBuy/redeemBuyResult'], r) //-- 赎回转认购结果

/********************** 赎回转申购 **********************/
const subscribeBuyList = r => require(['@/views/subscribeBuy/subscribeBuyList'], r) //-- 赎回转申购 信息列表
const subscribeBuy = r => require(['@/views/subscribeBuy/subscribeBuy'], r) //-- 赎回转申购
const subscribeBuyNew = r => require(['@/views/subscribeBuy/subscribeBuyNew'], r) //-- 新增赎回转申购
const subscribeBuyResult = r => require(['@/views/subscribeBuy/subscribeBuyResult'], r) //-- 赎回转申购结果

/********************** 我的预约计划相关 **********************/
const myappointment = r => require(['@/views/appointment/myappointment'], r) //-- 我的预约计划
const appointment_redeemNew = r => require(['@/views/appointment/myappointment_redeemNew'], r) //-- 新建预约赎回
const appointment_buyNew = r => require(['@/views/appointment/myappointment_buyNew'], r) //-- 新建预约赎回转认购
const appointment_redeem = r => require(['@/views/appointment/myappointment_redeem'], r) //-- 预约赎回
const appointment_transformNew = r => require(['@/views/appointment/myappointment_transformNew'], r) //-- 新建预约转换
const appointment_transform = r => require(['@/views/appointment/myappointment_transform'], r) //-- 预约转换
const appointment_result = r => require(['@/views/appointment/myappointment_result'], r) //-- 预约结果
const appointmentSubscription = r => require(['@/views/appointmentSubscription/appointmentSubscription'], r) //-- 预约认购
const appointmentSubscriptionRes = r => require(['@/views/appointmentSubscription/appointmentSubscriptionRes'], r)

/********************** 银行卡管理 **********************/
const bankCards = r => require(['@/views/banksInfo/bankCards'], r) //-- 银行卡列表
const bankCard_trades = r => require(['@/views/banksInfo/bankCard_trades'], r) //-- 银行卡交易记录
const bankCard_add = r => require(['@/views/banksInfo/bankCard_add'], r) //-- 添加银行卡
const bankCard_newAdd = r => require(['@/views/banksInfo/bankCard_newAdd'], r) //-- 添加银行卡
const bankCard_result = r => require(['@/views/banksInfo/bankCard_result'], r) //-- 增开/换卡 结果
const bankCard_update = r => require(['@/views/banksInfo/bankCard_update'], r) //-- 换银行卡
const bankCard_update_result = r => require(['@/views/banksInfo/bankCard_update_result'], r) //-- 换银行卡结果
const bankCard_result_auditinprogress = r => require(['@/views/banksInfo/bankCard_result_auditinprogress'], r) //-- 换审核中
const bankCard_review_result = r => require(['@/views/banksInfo/bankCard_update_review_result'], r) //-- 换卡审核结果
const bankCard_change = r => require(['@/views/banksInfo/bankCard_change'], r) //-- 变更银行卡
const bank_explain = r => require(['@/views/banksInfo/bank_explain'], r) //-- 限额说明

/********************** 我的 **********************/
const mymessage = r => require(['@/views/myMessage/myMessage'], r) //-- 我的消息
const mymessageInfo = r => require(['@/views/myMessage/myMessageInfo'], r) //-- 我的消息 详情
const myintegral = r => require(['@/views/myMessage/myIntegral'], r) //-- 我的积分
const myWelfare = r => require(['@/views/myMessage/myWelfare'], r) //-- 福利兑换
const myselection = r => require(['@/views/accountInfo/myselection'], r) //-- 我的自选
const accountmanagement = r => require(['@/views/accountInfo/accountmanagement'], r) //-- 我的账户管理
const accountmanagementEdit = r => require(['@/views/accountInfo/accountmanagementEdit'], r) //-- 我的账户管理 修改
const fengxianceping = r => require(['@/views/accountInfo/fengxianceping'], r) //-- 我的风险测评
const fengxiancepingjieguo = r => require(['@/views/accountInfo/fengxiancepingjieguo'], r) //-- 我的风险测评结果
const accountEditPwd = r => require(['@/views/accountInfo/accountEditPwd'], r) //-- 密码修改
const accountEditPwdResult = r => require(['@/views/accountInfo/accountEditPwdResult'], r) //-- 密码修改 结果

const accountPhoneEditOld = r => require(['@/views/accountInfo/accountphoneeditOld'], r) //-- 校验旧手机号
const accountPhoneEditBank = r => require(['@/views/accountInfo/accountphoneeditBank'], r) //-- 校验银行卡
const accountPhoneEdit = r => require(['@/views/accountInfo/accountPhoneEdit'], r) //-- 我的手机号修改
const accountPhoneEditResult = r => require(['@/views/accountInfo/accountPhoneEditResult'], r) //-- 手机号修改 结果

/********************** 我的新增**********************/
const accountPhoneNumaId = r => require(['@/views/accountInfo/accountPhoneNumaId'], r) //-- 我的--重置密码(姓名+身份证号码)
const accountPhoneMassage = r => require(['@/views/accountInfo/accountPhoneMassage'], r) //-- 我的--重置密码(手机号及短信校验)
const accountPhonePasswordRest = r => require(['@/views/accountInfo/accountPhonePasswordRest'], r) //-- 我的--重置密码(密码重置)
const accountPhoneSucess = r => require(['@/views/accountInfo/accountPhoneSucess'], r) //-- 我的--重置密码(完成)

/********************** 协议列表 **********************/
const agreement = r => require(['@/views/agreement/agreement'], r) //-- 协议列表 -- 最低型
const agreements = r => require(['@/views/agreement/agreements'], r) //-- 协议列表 -- 安全型
const agreementResult = r => require(['@/views/agreement/agreementResult'], r) //-- 协议列表 -- 修改结果

/********************** 资产证明 **********************/
const myAssetProof = r => require(['@/views/assetProof/myAssetProof'], r) //-- 资产证明
const myAssetProofInfo = r => require(['@/views/assetProof/myAssetProofInfo'], r) //-- 申请
const myAssetProofResult = r => require(['@/views/assetProof/myAssetProofResult'], r) //-- 申请结果
const myAssetProofList = r => require(['@/views/assetProof/myAssetProofList'], r) //-- 申请记录列表

/************************* 网站跳转的部分页面 *************************/
const register = r => require(['@/views/jump/register'], r) //-- 首页的个人开户
const purchase_fund = r => require(['@/views/jump/purchase-fund'], r) //-- 购买非货币
const buy = r => require(['@/views/jump/buy'], r) //-- 购买货币
const forgot_password = r => require(['@/views/jump/forgot-password'], r) //-- 找回密码
const backH5 = r => require(['@/views/jump/backH5'], r) //-- 银行返回调用

const treatyList = r => require(['@/views/agreement/treatyList'], r) //-- 协议列表

/********************** 智能客服**********************/
const customerservice = r => require(['@/views/Customerservice/Customerservice'], r) //-- 智能客服
// const Customerservice_test = r => require(['@/views/Customerservice_test/Customerservice'],r) //-- 智能客服

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.ASSETS_PUBLICPATH,
  routes: [{
      path: '/backH5', //-- 登录
      name: 'backH5',
      component: backH5
    },
    {
      path: '/', //-- 登录
      name: 'login',
      component: login
    },
    {
      path: '/login', //-- 登录
      name: 'login',
      component: login
    },
    {
      path: '/register', //注册 -*****************- 相关
      name: 'register',
      component: registerComm,
      redirect: '/register/phone',
      children: [{
          path: 'phone', //注册账户
          name: 'phone',
          component: register_phone
        },
        {
          path: 'setPwd', //注册账户 -- 设置密码
          name: 'setPwd',
          component: register_setPwd
        },
        {
          path: 'phone/result', //注册账户 -- 注册成功
          name: 'phone/result',
          component: register_phone_result
        },
        {
          path: 'bank', //开户--银行卡绑定
          name: 'bank',
          component: register_bank
        },
        // {
        // 	path: 'bankCallBack', //开户--银行卡绑定--银行回调
        // 	name: 'bankCallBack',
        // 	component: register_bankCallBack
        // },
        {
          path: 'info', //开户--资料填写
          name: 'info',
          component: register_info
        },
        {
          path: 'risk', //开户--风险评测
          name: 'risk',
          component: register_risk
        },
        {
          path: 'riskResult', //开户--风险评测结果
          name: 'riskResult',
          component: register_riskResult
        },
        {
          path: 'resetPwdCheck', //开户--安全校验
          name: 'resetPwdCheck',
          component: register_resetPwdCheck
        },
        {
          path: 'resetPwd', //开户--重置密码
          name: 'resetPwd',
          component: register_resetPwd
        },
        {
          path: 'success', //开户--开户成功
          name: 'success',
          component: register_success
        },
        {
          path: 'fail', //开户--开户失败
          name: 'fail',
          component: register_fail
        }
      ]
    },
    {
      path: '/forgetpwd/select', //-- 找回密码 - 选择找回方式
      name: 'forgetpwdSelect',
      component: forgetpwdSelect
    },
    {
      path: '/forgetpwd/phone', //-- 找回密码 - 手机找回 - 验证手机
      name: 'forgetpwdPhone',
      component: forgetpwdPhone
    },
    {
      path: '/forgetpwd/info', //-- 找回密码 - 手机找回 - 证件信息
      name: 'forgetpwdInfo',
      component: forgetpwdInfo
    },
    {
      path: '/forgetpwd/bank', //-- 找回密码 - 手机找回 - 银行卡信息
      name: 'forgetpwdBank',
      component: forgetpwdBank
    },
    {
      path: '/forgetpwd/setpwd', //-- 找回密码 - 设置新的密码
      name: 'forgetpwdSetpwd',
      component: forgetpwdSetpwd
    },
    {
      path: '/forgetpwd/result', //-- 找回密码 - 结果
      name: 'forgetpwdResult',
      component: forgetpwdResult
    },
    /********** 基金购买 *******************************/
    {
      path: '/fundsList', //基金购买(基金列表)
      name: 'fundsList',
      component: fundsList
    },
    {
      path: '/fundPurchases', //基金购买(某一基金购买)
      name: 'fundPurchases',
      component: fundPurchases
    },
    {
      path: '/fundPurchases/success', //基金购买(某一基金购买 成功)
      name: 'fundPurchases/success',
      component: fundPurchases_success
    },
    {
      path: '/fundPurchases/success/remits', //基金购买(某一基金购买 汇款成功)
      name: 'fundPurchases/success/remits',
      component: fundPurchases_success_remits
    },
    {
      path: '/fundPurchases/fail', //基金购买(某一基金购买 失败)
      name: 'fundPurchases/fail',
      component: fundPurchases_fail
    },
    /********** 基金定投 *******************************/
    {
      path: '/fundsFixed', //基金定投--列表
      name: 'fundsFixed',
      component: fundsDate
    },
    {
      path: '/fundsFixed/buy', //基金定投--某一基金定投
      name: 'fundsFixed/buy',
      component: fundsDate_buy
    },
    {
      path: '/fundsFixed/buy/result', //基金定投--结果
      name: 'fundsFixed/buy/result',
      component: fundsDate_buy_result
    },
    {
      path: '/fundsFixed/buyNew', //基金定投--新增定投计划
      name: 'fundsFixed/buyNew',
      component: fundsDate_buyNew
    },
    {
      path: '/fundsFixed/edit', //基金定投--修改
      name: 'fundsFixed/edit',
      component: fundsDate_edit
    },
    {
      path: '/fundsFixed/edit/result', //基金定投--修改结果
      name: 'fundsFixed/edit/result',
      component: fundsDate_edit_result
    },
    /********** 基金赎回 转换 *******************************/
    {
      path: '/fundRedeem', //基金赎回
      name: 'fundRedeem',
      component: fundRedeem
    },
    {
      path: '/fundRedeem/result', //基金赎回 结果
      name: 'fundRedeem/result',
      component: fundRedeem_result
    },
    {
      path: '/fundTransform', //基金转换
      name: 'fundTransform',
      component: fundTransform
    },
    {
      path: '/fundTransform/result', //基金结果
      name: 'fundTransform/result',
      component: fundTransform_result
    },
    /********** 账户查询 *******************************/
    {
      path: '/accountQuery', //账户查询 
      name: 'accountQuery',
      component: q_accountQuery
    },
    {
      path: '/mymessage', //我的消息
      name: 'mymessage',
      component: mymessage
    },
    {
      path: '/messageInfo', //我的消息 详情
      name: 'messageInfo',
      component: mymessageInfo
    },
    /********** 我的预约及计划 *******************************/
    {
      path: '/myappointment', //我的预约计划列表
      name: 'myappointment',
      component: myappointment
    },
    {
      path: '/appointment/buyNew', //新建预约赎回转认购
      name: 'appointment/buyNew',
      component: appointment_buyNew
    },
    {
      path: '/appointment/redeemNew', //新建预约赎回
      name: 'appointment/redeemNew',
      component: appointment_redeemNew
    },
    {
      path: '/appointment/redeem', //预约赎回
      name: 'appointment/redeem',
      component: appointment_redeem
    },
    {
      path: '/appointment/transformNew', //新建预约转换
      name: 'appointment/transformNew',
      component: appointment_transformNew
    },
    {
      path: '/appointment/transform', //预约转换
      name: 'appointment/transform',
      component: appointment_transform
    },
    {
      path: '/appointment/result', //我的预约结果
      name: 'appointment/result',
      component: appointment_result
    },
    {
      path: '/appointment/subscription', //预约认购
      name: 'appointment/subscription',
      component: appointmentSubscription
    },
    {
      path: '/appointment/subscriptionRes', //预约认购
      name: 'appointment/subscriptionRes',
      component: appointmentSubscriptionRes
    },
    /********** 我的自选 *******************************/
    {
      path: '/myselection', //我的自选
      name: 'myselection',
      component: myselection
    },
    /********** 银行卡管理 *******************************/
    {
      path: '/bankCards', //银行卡列表
      name: 'bankCards',
      component: bankCards
    },
    {
      path: '/bankCard/add', //添加银行卡
      name: 'bankCards/add',
      component: bankCard_add
    },
    {
      path: '/bankCard/newAdd', //银行卡签约
      name: '/bankCard/newAdd',
      component: bankCard_newAdd
    },
    {
      path: '/bankCard/update', //换卡 
      name: 'bankCards/update',
      component: bankCard_update
    },
    {
      path: '/bankCard/update/result', //换卡申请结果
      name: 'bankCards/update/result',
      component: bankCard_update_result
    },
    {
      path: '/bankCard/bankCard_result_auditinprogress', //换卡审核中
      name: 'bankCards/bankCard_result_auditinprogress',
      component: bankCard_result_auditinprogress
    },
    {
      path: '/bankCard/trades', //银行卡交易列表
      name: 'bankCard/trades',
      component: bankCard_trades
    },
    {
      path: '/bankCard/result', //银行卡操作结果(增开,换卡)
      name: 'bankCard/result',
      component: bankCard_result
    },
    {
      path: '/bankCard/update/review/result', //换卡申请审批结果
      name: 'bankCard/update/review/result',
      component: bankCard_review_result
    },
    {
      path: '/bankCard/change', //变更银行卡
      name: 'bankCard/change',
      component: bankCard_change
    },
    {
      path: '/bank/explain', //变更银行卡
      name: 'bank/explain',
      component: bank_explain
    },
    {
      path: '/myintegral', //我的积分
      name: 'myintegral',
      component: myintegral
    },
    {
      path: '/welfare', //福利兑换
      name: 'welfare',
      component: myWelfare
    },
    /********** 账户信息 *******************************/
    {
      path: '/myaccount/info', //我的持仓详情
      name: 'myaccount/info',
      component: myaccount_info
    },
    {
      path: '/myaccount/inTheWay', //在途交易
      name: 'myaccount/inTheWay',
      component: myaccount_inTheWay
    },
    {
      path: '/myaccount/income', //累计收益
      name: 'myaccount/income',
      component: myaccount_income
    },
    {
      path: '/account/phoneOld', //校验手机号
      name: 'account/phoneOld',
      component: accountPhoneEditOld
    },
    {
      path: '/account/phoneBank', //校验银行卡
      name: 'account/phoneBank',
      component: accountPhoneEditBank
    },
    {
      path: '/account/phoneEdit', //手机号修改 
      name: 'account/phoneEdit',
      component: accountPhoneEdit
    },
    {
      path: '/account/phoneEdit/result', //手机号修改 结果
      name: '/account/phoneEdit/result',
      component: accountPhoneEditResult
    },
    /********************** 我的新增**********************/
    {
      path: '/account/accountPhoneNumaId', //-- 我的--重置密码(姓名+身份证号码)
      name: '/account/accountPhoneNumaId',
      component: accountPhoneNumaId
    },
    {
      path: '/account/accountPhoneMassage', //-- 我的--重置密码(手机号及短信校验)
      name: '/account/accountPhoneMassage',
      component: accountPhoneMassage
    },
    {
      path: '/account/accountPhonePasswordRest', //-- 我的--重置密码(密码重置)
      name: '/account/accountPhonePasswordRest',
      component: accountPhonePasswordRest
    },
    {
      path: '/account/accountPhoneSucess', //-- 我的--重置密码(完成)
      name: '/account/accountPhoneSucess',
      component: accountPhoneSucess
    },
    {
      path: '/account/editPwd', //设置新密码
      name: 'account/editPwd',
      component: accountEditPwd
    },
    {
      path: '/account/editPwd/result', //密码修改成功
      name: 'account/editPwd/result',
      component: accountEditPwdResult
    },
    /********** 资产证明信息 *******************************/
    {
      path: '/myaccount/assetProof', //资产证明
      name: 'myaccount/assetProof',
      component: myAssetProof
    },
    {
      path: '/myaccount/assetProofInfo', //资产证明 申请记录列表
      name: 'myaccount/assetProofInfo',
      component: myAssetProofInfo
    },
    {
      path: '/myaccount/assetProofList', //资产证明 申请记录列表
      name: 'myaccount/assetProofList',
      component: myAssetProofList
    },
    {
      path: '/myaccount/assetProofResult', //资产证明 申请结果
      name: 'myaccount/assetProofResult',
      component: myAssetProofResult
    },
    {
      path: '/', //中间主要公用部分
      name: 'tkamc',
      component: tkamc,
      redirect: '/myaccount',
      children: [{
          path: '/myaccount', //我的资产
          name: 'myaccount',
          component: myaccount
        },


        {
          path: '/fengxianceping', //我的风险评测修改
          name: 'fengxianceping',
          component: fengxianceping
        },
        {
          path: '/fengxiancepingjieguo', //我的风险评测结果
          name: 'fengxiancepingjieguo',
          component: fengxiancepingjieguo
        },
        {
          path: '/agreement', //协议修改 -- C1最低型
          name: 'agreement',
          component: agreement
        },
        {
          path: '/agreements', //协议修改 -- C1安全型以上
          name: 'agreements',
          component: agreements
        },
        {
          path: '/agreementResult', //协议修改 结果页
          name: 'agreementResult',
          component: agreementResult
        }
      ]
    },
    /********** 赎回转认购 *******************************/
    {
      path: '/redeemBuyList', //赎回转认购 列表信息
      name: 'redeemBuyList',
      component: redeemBuyList
    },
    {
      path: '/redeemBuy', //赎回转认购
      name: 'redeemBuy',
      component: redeemBuy
    },
    {
      path: '/redeemBuyNew', //新增赎回转认购
      name: 'redeemBuyNew',
      component: redeemBuyNew
    },
    {
      path: '/redeemBuyResult', //赎回转认购结果
      name: 'redeemBuyResult',
      component: redeemBuyResult
    },
    /********** 赎回转申购 *******************************/
    {
      path: '/subscribeBuyList', //赎回转申购 列表信息
      name: 'subscribeBuyList',
      component: subscribeBuyList
    },
    {
      path: '/subscribeBuy', //赎回转申购
      name: 'subscribeBuy',
      component: subscribeBuy
    },
    {
      path: '/subscribeBuyNew', //新增赎回转申购
      name: 'subscribeBuyNew',
      component: subscribeBuyNew
    },
    {
      path: '/subscribeBuyResult', //赎回转申购结果
      name: 'subscribeBuyResult',
      component: subscribeBuyResult
    },

    /********** 账户管理相关 *******************************/
    {
      path: '/accountmanagement', //我的账户
      name: 'accountmanagement',
      component: accountmanagement
    },
    {
      path: '/accountmanagementEdit', //我的账户 补充资料
      name: 'accountmanagementEdit',
      component: accountmanagementEdit
    },

    {
      path: '/backPages', //网站首页登录 回调页面
      name: 'backPages',
      component: () => import('@/components/backPages/detectioning')
    },
    {
      path: '/tkamc/register', //--网站跳转 用户注册
      nmae: 'register',
      component: register
    },
    {
      path: '/tkamc/purchase-fund/:fCode', //--网站跳转 购买非货币
      name: 'purchase_fund',
      component: purchase_fund
    },
    {
      path: '/tkamc/buy/:fCode', //--网站跳转 购买货币
      name: 'buy',
      component: buy
    },
    {
      path: '/tkamc/forgot-password', //--网站跳转 密码找回
      name: 'forgot_password',
      component: forgot_password
    },
    // ------------------智能客服-------------
    {
      path: '/customerservice', //--智能客服
      name: 'customerservice',
      component: customerservice
    },
    // {
    // 	path:'/Customerservice_test', //--智能客服
    // 	name:'Customerservice_test',
    // 	component:Customerservice_test
    // },

    {
      path: '/treatyList', //--协议列表
      name: 'treatyList',
      component: treatyList
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js